export const modalStyles = ({maxWidth = '600px', overflow = 'auto', styles = {}} = {}) => {
  return {
    overlay: {
      backgroundColor: "rgba(25,62,93, 0.6)",
      boxShadow: "0 7px 74px 0 rgba(0, 0, 0, 0.3)",
      "zIndex": "1040"
    },
    content: {
      "maxWidth": maxWidth,
      "padding": "0px",
      "display": "flex",
      "flexDirection": "column",
      "overflow": overflow,
      ...styles
    }
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/lib/helpers.js